export default __webpack_public_path__ + "static/media/ROY KNOX -  Over My Head (Feat. Mike Robert) [NCS Release].3d4c8e65.mp3";